<template>
    <div class="card height-100">
      <header class="header-card">
        <p>
          {{ $t('editionClient.generalTitle.roleVendeur')}}
        </p>
      </header>
      <div class="card-content">
        <div class="columns">
          <div class="column is-narrow">
            <b-field :label="$t('editionClient.informations.role')">
              <b-select expanded v-model="tiers.role" class="is-220px-width">
                <option :value="null"></option>
                <option v-for="role in getRoleOfCurrentSociete" :value="role.code"
                        :key="role.code">
                  {{ $t(role.libelle) }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { SOCIETE_ROLE_VENTE } from '@/configuration/societe/societe';

const Societe = createNamespacedHelpers('societe');

export default {
  name: 'roleVendeur',
  props: {
    tiers: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...Societe.mapGetters({
      societeActive: 'societeActive',
    }),
    getRoleOfCurrentSociete() {
      return SOCIETE_ROLE_VENTE.filter((role) => {
        return this.societeActive.roles.includes(role.code);
      });
    },
  },
};
</script>

<style scoped>

</style>
